import React from "react"
import { theme } from "../theme.css"

export const HeadingLine = () => {
  return (
    <hr style={{ border: `1px solid ${theme.colors.text}`, width: "100%" }} />
  )
}
